// Canonical public URL for share links & previews — the live custom domain.
export const SITE_URL = "https://xauportal.com";

function openPopup(url) {
  try {
    const w = 600, h = 560;
    const top = window.top || window;
    const y = (top.outerHeight || window.screen.availHeight) / 2 + (top.screenY || 0) - h / 2;
    const x = (top.outerWidth || window.screen.availWidth) / 2 + (top.screenX || 0) - w / 2;
    const popup = window.open(url, "_blank", `noopener,noreferrer,width=${w},height=${h},top=${y},left=${x}`);
    if (popup) return;
  } catch { /* cross-origin iframe — fall through */ }
  window.open(url, "_blank", "noopener,noreferrer");
}

export function shareFacebook(url, quote) {
  const u = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(quote || "")}`;
  openPopup(u);
}

export function shareTwitter(url, text) {
  const u = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text || "")}`;
  openPopup(u);
}

export function shareWhatsApp(url, text) {
  const u = `https://wa.me/?text=${encodeURIComponent(`${text ? text + " " : ""}${url}`)}`;
  window.open(u, "_blank", "noopener,noreferrer");
}
